import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, EMPTY } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';

// Services
import { LoadingIndicatorService } from '@app/services/loading-indicator.service';
import { GetPetGQL } from '@app/services/graphql.service';
import { GraphQLErrorUtilsService } from '@app/services/utils/graphql-error-utils.service';
import { AuthService } from '@app/auth/auth.service';

@Injectable()
export class PetInfoResolver implements Resolve<any> {
  constructor(
    private router: Router,
    private getPet: GetPetGQL,
    private errorUtils: GraphQLErrorUtilsService,
    private authService: AuthService,
    private loadingIndicatorService: LoadingIndicatorService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    this.loadingIndicatorService.show();

    // Get the passing "Pet ID"
    const petId = route.paramMap.get('id');

    // Gwt the "account ID" first.
    return this.authService.fetchAccountId().pipe(
      finalize(() => this.loadingIndicatorService.hide()),
      switchMap(() => this.getPet.fetch({ petId })),
      map((res) => res.data.getPet),
      catchError((error) => {
        console.log(
          'PetInfoResolver ERROR:',
          this.errorUtils.parseGraphQLError(error).outputMessage
        );

        // Back route to the "root".
        this.router.navigate(['/']);

        return EMPTY;
      })
    );
  }
}
